import React, { createRef } from "react";

import "./DefaultLayout.scss";

export const topbarRef = createRef();

export function DefaultLayout({ name, scrollRef, children }) {
  return (
    <div className={`ws-page-default ws-page-default--${name}`} ref={scrollRef}>
      <div className="ws-page-default__topbar" ref={topbarRef} />
      {children}
    </div>
  );
}
